export const SUCCESS_GET_BOK_1_HEADERS = 'SUCCESS_GET_BOK_1_HEADERS';
export const FAILED_GET_BOK_1_HEADERS = 'FAILED_GET_BOK_1_HEADERS';
export const SUCCESS_GET_BOK_2_LINES = 'SUCCESS_GET_BOK_2_LINES';
export const FAILED_GET_BOK_2_LINES = 'FAILED_GET_BOK_2_LINES';
export const RESET_GET_BOK_2_LINES = 'RESET_GET_BOK_2_LINES';
export const SUCCESS_GET_BOK_3_LINES_DATA = 'SUCCESS_GET_BOK_3_LINES_DATA';
export const FAILED_GET_BOK_3_LINES_DATA = 'FAILED_GET_BOK_3_LINES_DATA';
export const RESET_GET_BOK_3_LINES_DATA = 'RESET_GET_BOK_3_LINES_DATA';
export const SUCCESS_GET_BOK_WITH_PRICINGS = 'SUCCESS_GET_BOK_WITH_PRICINGS';
export const FAILED_GET_BOK_WITH_PRICINGS = 'FAILED_GET_BOK_WITH_PRICINGS';
export const SUCCESS_SELECT_PRICING = 'SUCCESS_SELECT_PRICING';
export const FAILED_SELECT_PRICING = 'FAILED_SELECT_PRICING';
export const RESET_NEED_TO_UPDATE_PRICINGS = 'RESET_NEED_TO_UPDATE_PRICINGS';
export const SET_NEED_TO_UPDATE_PRICINGS = 'SET_NEED_TO_UPDATE_PRICINGS';
export const SUCCESS_GET_DE_STATUS = 'SUCCESS_GET_DE_STATUS';
export const FAILED_GET_DE_STATUS = 'FAILED_GET_DE_STATUS';
export const SUCCESS_BOOK_FREIGHT = 'SUCCESS_BOOK_FREIGHT';
export const FAILED_BOOK_FREIGHT = 'FAILED_BOOK_FREIGHT';
export const SUCCESS_CANCEL_FREIGHT = 'SUCCESS_CANCEL_FREIGHT';
export const FAILED_CANCEL_FREIGHT = 'FAILED_CANCEL_FREIGHT';
export const SUCCESS_UPDATE_BOK_1 = 'SUCCESS_UPDATE_BOK_1';
export const FAILED_UPDATE_BOK_1 = 'FAILED_UPDATE_BOK_1';
export const SUCCESS_SEND_EMAIL = 'SUCCESS_SEND_EMAIL';
export const FAILED_SEND_EMAIL = 'FAILED_SEND_EMAIL';
export const SUCCESS_ADD_BOK_LINE = 'SUCCESS_ADD_BOK_LINE';
export const FAILED_ADD_BOK_LINE = 'FAILED_ADD_BOK_LINE';
export const SUCCESS_UPDATE_BOK_LINE = 'SUCCESS_UPDATE_BOK_LINE';
export const FAILED_UPDATE_BOK_LINE = 'FAILED_UPDATE_BOK_LINE';
export const SUCCESS_DELETE_BOK_LINE = 'SUCCESS_DELETE_BOK_LINE';
export const FAILED_DELETE_BOK_LINE = 'FAILED_DELETE_BOK_LINE';
export const SUCCESS_BOK_REPACK = 'SUCCESS_BOK_REPACK';
export const FAILED_BOK_REPACK = 'FAILED_BOK_REPACK';



// WEBPACK FOOTER //
// ./src/state/constants/bokConstants.js